import { render, staticRenderFns } from "./rate-extras-list.vue?vue&type=template&id=693965c3"
import script from "./rate-extras-list.vue?vue&type=script&lang=js"
export * from "./rate-extras-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports